import { z } from "zod";
import { TFunction } from "i18next";

export const createLoginSchema = (t: TFunction) => z.object({
  email: z.string().email({ message: t("validationInvalidEmail") }),
  password: z
    .string()
    .min(8, {
      message: t("validationPasswordMinLength"),
    })
    .regex(/[a-zA-Z]/, {
      message: t("validationPasswordMinLength"),
    })
    .regex(/[0-9]/, {
      message: t("validationPasswordMinLength"),
    }),
});

// Legacy export for backward compatibility
export const LoginSchema = z.object({
  email: z.string().email({ message: "Invalid email address" }),
  password: z
    .string()
    .min(8, {
      message:
        "Password must be at least 8 characters, at least one letter and one number",
    })
    .regex(/[a-zA-Z]/, {
      message:
        "Password must be at least 8 characters, at least one letter and one number",
    })
    .regex(/[0-9]/, {
      message:
        "Password must be at least 8 characters, at least one letter and one number",
    }),
});

export type LoginModel = z.infer<ReturnType<typeof createLoginSchema>>;
